"use strict";exports.unsubscribeAll=function(s){for(var u;s.length>0;)null===(u=s.pop())||void 0===u||u.unsubscribe()};
//# sourceMappingURL=unsubscribeAll.cjs.map
